import styled, { css } from 'styled-components';

export const ButtonText1Css = css`
  font-family: ${props => props.theme.v2.fontFamily.default};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
`;

export const ButtonText2Css = css`
  font-family: ${props => props.theme.v2.fontFamily.default};
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
`;

// Declaring the styled component
const ButtonText = styled.span`
  ${props => props.size === 100 && ButtonText1Css}
  ${props => props.size === 200 && ButtonText2Css}
`;

export default ButtonText;
